import React from 'react'
import { animated, useSpring } from 'react-spring'
import styled from 'styled-components'
import { Button } from 'nzk-react-components'
import Close from 'components/UI/Icons/Close'
import { words } from 'lodash-es'

export type EnterAnimationType = 'none' | 'slideInUp' | 'slideInLeft' | 'slideInRight'
interface IProps {
  title?: any,
  description?: string,
  children?: any,
  enterAnimationDelay?: number,
  enterAnimationType?: EnterAnimationType,
  dismiss?: () => void
}

const Wrapper = styled(animated.div)`
  position: absolute;
  background-color: #341644;
  color: #fff;
  border-radius: 45px;
  max-height: 512px;
  width: 760px;
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
  box-shadow: 0 -5px 0 #531D75, 0 10px 0 #1C042B, 0 14px 0 rgba(0,0,0,0.3);
`

const Header = styled.div`
  position: relative;
  display: flex;
  text-align: center;
  padding: 0 30px;
  transform: translateY(-50%);
  padding-bottom: 20px;
`

const Titles = styled.div`
  font-family: 'Rammetto One';
  margin: 0 25px;
  flex: 1;
`

const Title = styled.div`
  font-size: 37px;
  line-height: 48px;
  color: #fff;
  text-shadow: 0 5px 0 #AFAFAF, 0 8px 0 rgba(0,0,0,0.5);
`

const SubTitle = styled.div<{subtitleIsLong: boolean}>`
  font-size: ${props => props.subtitleIsLong ? '19px' : '23px'};
  color: #8E38B4;
  margin-top: -10px;
  text-shadow: 0 4px 0 #560084, 0 7px 0 rgba(0,0,0,0.5);
`

const Content = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: -25px;
  width: calc(100% - 140px);
  border-radius: 12px;
`

const QuitButton = styled.div`
  position: absolute;
  top: 0px;
  right: 0;
  transform: translate(20%, -20%);
  z-index: 2;
`

export default ({
  title,
  description,
  children,
  enterAnimationDelay = 1000,
  enterAnimationType = 'slideInUp',
  dismiss
} : IProps) => {
  const from = { x: 0, y: 0 }

  switch (enterAnimationType) {
    case 'slideInUp': from.y = window.innerHeight; break
    case 'slideInLeft': from.x = -window.innerWidth; break
    case 'slideInRight': from.x = window.innerWidth; break
  }

  const springOptions = {
    from,
    x: 0,
    y: 0,
    delay: enterAnimationDelay,
    immediate: enterAnimationType === 'none'
  }

  const { x, y } = useSpring(springOptions)

  const transforms = () => ({
    slideInUp: { y },
    slideInLeft: { x },
    slideInRight: { x },
    none: {}
  })

  const subtitleIsLong = words(description).length > 14

  const onWrapperClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return <Wrapper className='modal' onClick={onWrapperClick} style={{ ...transforms()[enterAnimationType] }}>
    { dismiss && <QuitButton>
      <Button size='regular' backgroundColor='#EC1A18' round onClick={dismiss}>
        <Close />
      </Button>
    </QuitButton> }
    <Header>
      <Titles>
        <Title>{title}</Title>
        <SubTitle subtitleIsLong={subtitleIsLong} dangerouslySetInnerHTML={{ __html: description || '' }} />
      </Titles>
    </Header>
    <Content className='modal--content'>
      {children}
    </Content>
  </Wrapper>
}
